import { render, staticRenderFns } from "./RiskParity.vue?vue&type=template&id=bd605f4a&scoped=true&"
import script from "./RiskParity.vue?vue&type=script&lang=js&"
export * from "./RiskParity.vue?vue&type=script&lang=js&"
import style0 from "./RiskParity.vue?vue&type=style&index=0&id=bd605f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd605f4a",
  null
  
)

export default component.exports